import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TileService } from '../../../widgets/services/tile.service';
import { ISearchItem } from '../../services/search.service';
import { PreferencesService } from '../../services/preferences.service';
import { displayModal } from '../../../widgets/models/utils/general';
import { SearchPreviewComponent } from '../search-preview/search-preview.component';
import { DatePreferencePipe, SafeHtmlPipe } from '../../../../modules/fwcore';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-search-item',
  standalone: true,
  imports: [SafeHtmlPipe, SearchPreviewComponent,DatePreferencePipe, FormsModule,CommonModule],
  templateUrl: './search-item.component.html',
  styleUrls: ['./search-item.component.scss']
})
export class SearchItemComponent implements OnInit {
  @Input() item: ISearchItem = { id: "", title: "", content: "", extension: "", size: "", sizeNumeric: 0, date: new Date(), url: "", folder: "", source: "", thumbnail: "" };

  showThumbnails: boolean = true;
  itemUrl: string = "";
  @ViewChild('previewtemplate') public previewtemplate?: TemplateRef<any>;

  constructor(private modalService: NgbModal, private prefs: PreferencesService, private tileService: TileService) {
    const preferences = this.prefs.getPreferences();
    const prefkeys: string[] = Object.keys(preferences);

    if (prefkeys.includes("wb.search.showThumbnails")) {
      this.showThumbnails = preferences["wb.search.showThumbnails"];
    }
  }

  ngOnInit(): void {
  }

  public downloadSearchFile(id: string) {
    this.tileService.downloadCaseStudyFile(id).then((data) => {
      this.fileDownload(data.fileBinary, "application/vnd.openxmlformats", data.fileName);
      (document.getElementsByClassName('case-study-edit-spinner')[0] as HTMLElement).style.display = 'none';
    });
  }
  public downloadDiamondFile(id: string) {
    this.tileService.getfile(id).then((data) => {
      this.fileDownload(data.content, "application/vnd.openxmlformats", data.fileName);
      (document.getElementsByClassName('case-study-edit-spinner')[0] as HTMLElement).style.display = 'none';
    });
  }
  public downloadShareableIpFile(id: string) {
    this.tileService.downloadShareableIpFile(id).then((data) => {
      this.fileDownload(data.fileBinary, "application/vnd.openxmlformats", data.fileName);
    });
  }
  fileDownload(data: any, type: any, fileName: any) {
    const linkSource = `data:${type};base64,${data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  downloadFile(ev: any) {
    ev?.preventDefault();
    this.itemUrl = this.item.url;
    const url = new URL(this.itemUrl);
    const path = url.pathname;
    const pathParts = path.split('/');
    const id = pathParts[pathParts.length - 1];
    const fileid = this.item.id;

    if (this.item.url.includes("smartbank/case-study")) {
      this.downloadSearchFile(id);
    }
    else if (this.item.url.includes("diamondip/download")) {
      this.downloadDiamondFile(id);
    }
    else if (this.item.source === "Diamond IP" && this.item.url === "https://wb.isg-one.com/diamondip/DB") {
      this.downloadDiamondFile(fileid);
    }
    else if (this.item.source === "Shareable IP" && this.item.url === "https://wb.isg-one.com/shareableIp/DB") {
      this.downloadShareableIpFile(fileid);
    }
    else if (this.item.source === "Case Studies" && this.item.url === "https://wb.isg-one.com/casestudy/DB") {
      this.downloadSearchFile(fileid);
    }
    else {
      window.open(this.item.url, '_blank', 'noreferrer')

    }
  }

  getIcon(fileName: string) {
    if (fileName.toLowerCase().endsWith('.pdf')) {
      return '../assets/images/workbench/market/pdfimg.png';
    }
    else if (fileName.endsWith('.pptx') || fileName.endsWith('.ppt') || fileName.endsWith('.pptx.PPT')) {
      return '../assets/images/workbench/market/pptimg.png';
    }
    if (fileName.toLowerCase().endsWith('.docx') || fileName.toLowerCase().endsWith('.doc')) {
      return '../assets/images/workbench/market/wordimg.png';
    }

    else if (fileName.toLowerCase().endsWith('.xlsx') || fileName.toLowerCase().endsWith('.xls') || fileName.endsWith('.xlsm')) {
      return '../assets/images/workbench/market/excelimg.png';
    }
    else if (fileName.endsWith('.zip')) {
      return '../assets/images/workbench/market/zipimg.png';
    }
    else {
      return '';
    }
  }

  public showPreview() {
    displayModal(this.previewtemplate, 'xl', { title: "Doc Preview", showSave: false, showCancel: false, showCross: true, scrollable: false }, this.modalService);
  }
}
